module.exports = "<div #content class=\"app-modal-container-wrapper\">\n  <div>\n    <upload-excel-file-interface (modalAction)=\"modalActionsHandler($event)\"></upload-excel-file-interface>\n\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/users/user-management-upload-users-excel-modal/user-management-upload-users-excel-modal.component.html
// module id = ./src/app/admin/users/user-management-upload-users-excel-modal/user-management-upload-users-excel-modal.component.html
// module chunks = main